<template>
    <div class="surface-overlay relative">
        <div class="grid">
            <div class="col-12 md:col-12">
                <div class="card p-fluid">
                    <h3>Payment Details</h3>

                    <div v-if="loading" class="field">
                        <label>Loading payment details…</label>
                    </div>

                    <div v-else-if="error" class="field">
                        <label class="text-red-500">Error: {{ error }}</label>
                    </div>

                    <div v-else>
                        <div class="field">
                            <label>Description</label>
                            <InputText :disabled="true" :value="paymentFlowDetails.paymentRequest.description"/>
                        </div>

                        <div class="field">
                            <label>Amount</label>
                            <InputText :disabled="true" :value="paymentFlowDetails.paymentRequest.amount"/>
                        </div>

                        <div class="field">
                            <Button
                                label="Pay"
                                class="mr-2 mb-2"
                                :disabled="!readyToPay"
                                @click="pay"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {initStripe} from '@/utils/loadExternalScriptOnce';
import StripeService from "@/service/StripeService";
import SystemConfigService from "@/service/SystemConfigService";

export default {
    name: 'UsdPaymentButton',
    props: {
        companyReference: {type: [String, Number], required: false, default: null},
        invoiceReference: {type: [String, Number], required: false, default: null},
        signatureReference: {type: [String, Number], required: false, default: null},
    },
    data() {
        return {
            loading: true,
            error: '',
            readyToPay: false,
            paymentFlowDetails: null
        };
    },
    async mounted() {
        try {
            // 1) Load Stripe script once (safe to call multiple times across the app)
            try {
                const stripeJsUrl = await SystemConfigService.getStripeJsUrl();
                await initStripe(stripeJsUrl.data);
            } catch (e) {
                console.error('[App] Could not init Stripe', e);
            }

            console.debug('[UsdPaymentButton][mounted] Getting payment details for : ',
                this.companyReference, this.invoiceReference, this.signatureReference);

            const res = await StripeService.getPaymentFlowDetails(
                this.companyReference,
                this.invoiceReference,
                this.signatureReference
            );

            if (res.data.error) {
                this.error = res.data.error;
                console.log('[UsdPaymentButton][mounted] this.error = ', this.error);
                this.readyToPay = false;
            } else {
                this.paymentFlowDetails = res.data;
                console.log('[UsdPaymentButton][mounted] this.paymentFlowDetails  = ', this.paymentFlowDetails);
                this.readyToPay = true;
            }
        } catch (e) {
            console.error('[UsdPaymentButton][mounted] Error:', e);
            this.error = e?.message || 'Failed to get payment flow details';
        } finally {
            this.loading = false;
        }
    },
    methods: {
        pay() {
            try {
                const paymentRequest = this.paymentFlowDetails.paymentRequest;
                const url = this.paymentFlowDetails.url;

                console.log('Open payment page with data: ', paymentRequest, url);

                window.location.href = url;
            } catch (e) {
                console.error('[UsdPaymentButton][pay] Error:', e);
                this.error = 'Could not start payment.';
            }
        },
    },
};
</script>
